<mat-dialog-content>
    <strong>
        You have tasks assigned to you that have
        not been completed. Are you sure you
        want to log out?
    </strong>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">Sign Out</button>
</mat-dialog-actions>